import { render, staticRenderFns } from "./ListNotifikasi.vue?vue&type=template&id=9d68e918"
import script from "./ListNotifikasi.vue?vue&type=script&lang=js"
export * from "./ListNotifikasi.vue?vue&type=script&lang=js"
import style0 from "./ListNotifikasi.vue?vue&type=style&index=0&id=9d68e918&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports